import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  standalone: false,
  template: `
    <div class="alert" [ngClass]="'alert-' + severity">
      <ng-content></ng-content>
      <button *ngIf="closable" class="action-btn" style="margin-left: auto;" (click)="visible = false">
        <i class="pi pi-times"></i>
      </button>
    </div>
  `,
})
export class AlertComponent {
  @Input() severity: 'error' | 'success' | 'warning' | 'info' = 'info';
  @Input() closable = false;
  visible = true;
}
